const aiChatStateSelector = (state) => state?.ui?.aiChat || {};

export const aiChatIsOpenSelector = (state) =>
  Boolean(aiChatStateSelector(state).isOpen);

export const aiChatPanelWidthSelector = (state) => {
  const width = aiChatStateSelector(state).panelWidth;
  return Number.isFinite(width) ? width : null;
};

export const aiChatActiveViewSelector = (state) =>
  aiChatStateSelector(state).activeView || null;

export const aiChatSelectedThreadIdSelector = (state) => {
  const threadId = aiChatStateSelector(state).selectedThreadId;
  return threadId === undefined ? null : threadId;
};
